// Copyright Robert Bosch GmbH. All rights reserved, also regarding any disposal, exploration, reproduction,
// editing, distribution, as well as in the event of applications for industrial property rights.
import React from "react";
const dashboard = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25.5"
    height="16"
    viewBox="0 0 25.5 25.5"
  >
    <g
      id="Dashboard_Deactive_state"
      data-name="Dashboard Deactive state"
      transform="translate(0.75 0.75)"
    >
      <path
        id="Path_315"
        data-name="Path 315"
        d="M0,21H24v3H0ZM0,10.5H24V18H0ZM10.5,0H24V7.5H10.5ZM0,0H7.5V7.5H0Z"
        fill="none"
        stroke="#8c9b9e"
        strokeWidth="1.5"
        fillRule="evenodd"
      />
    </g>
  </svg>
);

const parkingManagement = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25.5"
    height="25.5"
    viewBox="0 0 25.5 25.5"
  >
    <g
      id="Parking_Mgmt_Deactive_State"
      data-name="Parking Mgmt Deactive State"
      transform="translate(0.75 0.75)"
    >
      <g id="Group_910" data-name="Group 910" opacity="0.48">
        <path
          id="Path_270"
          data-name="Path 270"
          d="M32.242,12.8H17.558A4.68,4.68,0,0,0,12.9,17.458V32.142A4.68,4.68,0,0,0,17.558,36.8H32.242A4.68,4.68,0,0,0,36.9,32.142V17.49A4.645,4.645,0,0,0,32.242,12.8ZM30.948,24.153a4.474,4.474,0,0,1-1.035,1.617A4.817,4.817,0,0,1,28.231,26.9a5.493,5.493,0,0,1-2.232.42h-3.04v5.11H19.628v-15.2h6.4a5.544,5.544,0,0,1,2.264.453,4.751,4.751,0,0,1,1.65,1.164A5.22,5.22,0,0,1,31.3,22.277,5.362,5.362,0,0,1,30.948,24.153Z"
          transform="translate(-12.9 -12.8)"
          fill="none"
          stroke="#102e35"
          strokeWidth="1.5"
        />
        <path
          id="Path_271"
          data-name="Path 271"
          d="M47.04,36.5H44v3.687h3.04a1.919,1.919,0,0,0,.744-.162,1.607,1.607,0,0,0,.615-.42,2.072,2.072,0,0,0,.42-.615,1.919,1.919,0,0,0,.162-.744,1.645,1.645,0,0,0-.55-1.294A2.053,2.053,0,0,0,47.04,36.5Z"
          transform="translate(-33.941 -28.834)"
          fill="none"
          stroke="#102e35"
          strokeWidth="1.5"
        />
      </g>
    </g>
  </svg>
);

const organizationManagement = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="192"
    height="192"
    viewBox="0 0 192 192"
  >
    <path
      d="M108.748 105.6l2.569-2.331c-6.12-9.17-15.061-16.213-25.429-20.044C96.7 77.01 104 65.359 104 52.028c0-19.836-16.15-35.973-36-35.973S32 32.192 32 52.028c0 13.308 7.276 24.943 18.056 31.165C30.2 90.517 16 109.631 16 132h8c0-24.262 19.738-44 44-44 15.542 0 29.603 8.257 37.454 20.923a45.432 45.432 0 0 1 3.294-3.324zM40 52.027c0-15.424 12.56-27.973 28-27.973s28 12.549 28 27.973S83.439 80 68 80 40 67.452 40 52.028zm135.688 81.993a37.303 37.303 0 0 0-1.539-6.644l-.865-2.626-8.456-.401c-.114-.2-.23-.398-.348-.596l3.822-7.555-1.858-2.049a37.04 37.04 0 0 0-10.807-8.225l-2.47-1.244-6.264 5.697c-.22-.062-.443-.12-.666-.176l-2.64-8.043-2.762-.135a37.254 37.254 0 0 0-6.814.288c-2.227.302-4.462.82-6.644 1.539l-2.626.865-.401 8.456c-.2.114-.398.23-.596.348l-7.555-3.822-2.049 1.858a37.049 37.049 0 0 0-8.225 10.807l-1.244 2.47 5.697 6.264c-.062.22-.12.443-.176.666l-8.043 2.64-.135 2.762c-.111 2.294-.015 4.586.288 6.814s.82 4.462 1.539 6.644l.865 2.626 8.456.401c.114.2.23.398.348.596l-3.822 7.555 1.858 2.049a37.051 37.051 0 0 0 10.807 8.224l2.469 1.245 6.262-5.694c.223.062.447.12.67.177l2.639 8.04 2.762.134a36.958 36.958 0 0 0 6.813-.287 37.303 37.303 0 0 0 6.645-1.54l2.626-.865.401-8.456c.2-.114.398-.23.596-.348l7.555 3.822 2.049-1.858a37.049 37.049 0 0 0 8.225-10.807l1.244-2.47-5.697-6.264c.062-.22.12-.443.176-.666l8.043-2.64.135-2.762a37.297 37.297 0 0 0-.288-6.814zm-14.926 6.062l-.393 2.412a21.497 21.497 0 0 1-1.057 3.997l-.85 2.293 5.096 5.602a28.959 28.959 0 0 1-3.183 4.182l-6.757-3.418-1.983 1.43a21.558 21.558 0 0 1-3.573 2.084l-2.218 1.022-.36 7.558a28.433 28.433 0 0 1-5.207.707l-2.361-7.196-2.419-.388a20.975 20.975 0 0 1-3.99-1.056l-2.292-.85-5.602 5.096a28.933 28.933 0 0 1-4.182-3.183l3.418-6.757-1.43-1.983a21.558 21.558 0 0 1-2.084-3.573l-1.022-2.218-7.558-.36a28.433 28.433 0 0 1-.707-5.207l7.19-2.36.393-2.412c.22-1.354.577-2.698 1.057-3.997l.85-2.293-5.096-5.602a28.959 28.959 0 0 1 3.183-4.182l6.757 3.418 1.983-1.43a21.558 21.558 0 0 1 3.573-2.084l2.218-1.022.36-7.558a28.433 28.433 0 0 1 5.207-.707l2.36 7.19 2.412.393c1.354.22 2.698.577 3.997 1.057l2.293.85 5.602-5.096a28.964 28.964 0 0 1 4.182 3.183l-3.418 6.757 1.43 1.983a21.558 21.558 0 0 1 2.084 3.573l1.022 2.218 7.558.36a28.433 28.433 0 0 1 .707 5.207l-7.19 2.36zm-29.057-13.086c-6.632 4.027-8.75 12.7-4.723 19.333 2.645 4.355 7.292 6.764 12.05 6.764a13.99 13.99 0 0 0 7.283-2.042c6.632-4.028 8.75-12.7 4.722-19.333-4.028-6.632-12.7-8.751-19.332-4.722zm10.436 17.182a6.037 6.037 0 0 1-8.286-2.024 6.038 6.038 0 0 1 2.024-8.285 6.034 6.034 0 0 1 8.285 2.024 6.037 6.037 0 0 1-2.023 8.285z"
      //  opacity="0.48"
    />
  </svg>
);

const userManagement = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26.102"
    height="26.102"
    viewBox="0 0 26.102 26.102"
  >
    <g
      id="user_management_deactive_state"
      data-name="user management deactive state"
      transform="translate(0.75 0.75)"
    >
      <path
        id="Union_47"
        data-name="Union 47"
        d="M0,24.6V21.527c0-3.383,5.535-6.151,12.3-6.151s12.3,2.768,12.3,6.151V24.6ZM6.15,6.151A6.15,6.15,0,1,1,12.3,12.3,6.151,6.151,0,0,1,6.15,6.151Z"
        fill="none"
        stroke="#102e35"
        strokeWidth="1.5"
        opacity="0.48"
      />
    </g>
  </svg>
);

const roleManagement = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="35.786"
    height="25.5"
    viewBox="0 0 35.786 25.5"
  >
    <g
      id="role_management_deactive_state"
      data-name="role management deactive state"
      transform="translate(0.75 0.75)"
    >
      <path
        id="Path_291"
        data-name="Path 291"
        d="M15.074,20.809c-4.011,0-12,2.006-12,6v3h24v-3C27.074,22.815,19.085,20.809,15.074,20.809Zm0-3a6,6,0,1,0-6-6A6.007,6.007,0,0,0,15.074,17.809Zm12.069,3.1a7.187,7.187,0,0,1,3.36,5.9v3H37.36v-3C37.36,23.346,31.36,21.375,27.143,20.912Zm-1.783-3.1a6,6,0,1,0,0-12,5.907,5.907,0,0,0-2.571.6,9.362,9.362,0,0,1,0,10.8A5.907,5.907,0,0,0,25.36,17.809Z"
        transform="translate(-3.074 -5.809)"
        fill="none"
        stroke="#102e35"
        strokeWidth="1.5"
        opacity="0.48"
      />
    </g>
  </svg>
);

const serviceRequest = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22.922"
    height="25.547"
    viewBox="0 0 22.922 25.547"
  >
    <g
      id="services_requested_deactive_state"
      data-name="services requested deactive state"
      transform="translate(0.758 0.751)"
    >
      <path
        id="Path_273"
        data-name="Path 273"
        d="M24.155,13.784a.214.214,0,0,0,.179-.175,7.414,7.414,0,0,0,0-2.461.214.214,0,0,0-.179-.175l-1.828-.287a.531.531,0,0,1-.347-.838l1.09-1.494a.215.215,0,0,0,0-.25,7.383,7.383,0,0,0-1.741-1.741.215.215,0,0,0-.25,0l-1.494,1.09a.532.532,0,0,1-.838-.347l-.287-1.828a.214.214,0,0,0-.175-.179,7.412,7.412,0,0,0-2.461,0,.214.214,0,0,0-.175.179l-.287,1.828a.532.532,0,0,1-.839.347l-1.493-1.09a.215.215,0,0,0-.25,0A7.384,7.384,0,0,0,11.043,8.1a.215.215,0,0,0,0,.25l1.09,1.494a.531.531,0,0,1-.347.838l-1.828.287a.215.215,0,0,0-.179.175,7.428,7.428,0,0,0,0,2.461.215.215,0,0,0,.179.175l1.828.287a.531.531,0,0,1,.347.838L11.046,16.4a.215.215,0,0,0,0,.25,7.378,7.378,0,0,0,1.741,1.741.215.215,0,0,0,.25,0l1.493-1.09a.532.532,0,0,1,.839.347l.287,1.828a.214.214,0,0,0,.175.179,7.412,7.412,0,0,0,2.461,0,.214.214,0,0,0,.175-.179l.287-1.828a.532.532,0,0,1,.839-.347l1.493,1.09a.215.215,0,0,0,.25,0,7.383,7.383,0,0,0,1.741-1.741.215.215,0,0,0,0-.25l-1.09-1.494a.532.532,0,0,1,.116-.743Zm-7.1,1.464a2.869,2.869,0,1,1,2.87-2.869h0A2.87,2.87,0,0,1,17.058,15.248Zm12.053,7.4a8.014,8.014,0,0,1-.85.644c0,.32-1.855,1.6-2.13,1.813a25.168,25.168,0,0,1-2.877,1.926,25.861,25.861,0,0,1-6.1,1.941,37.48,37.48,0,0,1-7.273-.718,8.347,8.347,0,0,0-2.155-.015V22.752c0-.012,0-.023,0-.035a6.4,6.4,0,0,1,2.262-1.056,10.416,10.416,0,0,1,3.8.015,9.732,9.732,0,0,0,3.078.018,18.849,18.849,0,0,0,2.5-.429c.86-.28,1.41-.241,1.724.323a.886.886,0,0,1-.366,1.173,7.4,7.4,0,0,1-2.077,1.123,25.836,25.836,0,0,1-3.341.7,22.02,22.02,0,0,0,2.158.539,16.042,16.042,0,0,0,4.546-.237c1.6-.382,4.007-2.459,5.017-2.825a2.08,2.08,0,0,1,1.69-.137C28.958,22.048,29.208,22.52,29.111,22.648Z"
        transform="translate(-7.726 -5)"
        fill="none"
        stroke="#102e35"
        strokeWidth="1.5"
        opacity="0.48"
      />
    </g>
  </svg>
);
const configuration = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 192">
    <path
      d="M146.002 116.002c-3.62 0-7.13.63-10.466 1.877l-3.541-3.542-31.336-31.336L76.78 59.123c.025-.06.045-.123.069-.183l.017-.048c.195-.498.374-1 .542-1.505.09-.27.177-.542.26-.814.077-.256.148-.513.218-.77v-.001c.058-.212.117-.423.17-.636.107-.426.203-.855.292-1.285l.038-.176c.071-.358.133-.718.192-1.079v-.001l.045-.266a31.315 31.315 0 0 0 .173-1.311l.03-.26c.058-.562.105-1.125.133-1.693l.001-.017c.026-.524.04-1.05.04-1.578C79 30.13 64.87 16 47.5 16c-.513 0-1.022.014-1.529.039-.182.008-.363.025-.545.036-.32.021-.641.043-.96.073-.227.022-.453.05-.68.077-.265.031-.53.063-.792.101-.259.037-.517.08-.774.123a31.642 31.642 0 0 0-1.526.296c-.173.039-.346.08-.518.12-.324.078-.647.158-.969.246-.121.033-.242.069-.363.103a31.27 31.27 0 0 0-1.086.33l-.18.06c-.408.136-.815.277-1.218.43l-.018.006a31.375 31.375 0 0 0-5.336 2.623l18.165 18.166c2.852 2.851 2.852 7.49 0 10.342s-7.49 2.852-10.342 0L20.663 31.006a31.372 31.372 0 0 0-2.627 5.348l-.002.005c-.151.4-.29.801-.425 1.204l-.068.2c-.115.355-.221.712-.324 1.07-.036.127-.073.253-.108.38a31.246 31.246 0 0 0-.365 1.487 31.08 31.08 0 0 0-.52 3.09c-.026.225-.054.45-.075.676-.031.319-.053.64-.074.962-.011.181-.028.361-.036.543A31.994 31.994 0 0 0 16 47.5C16 64.87 30.13 79 47.5 79c.528 0 1.054-.014 1.578-.04l.017-.001c.568-.028 1.131-.075 1.692-.133l.26-.03h.004a31.317 31.317 0 0 0 1.574-.217h.001c.36-.06.72-.122 1.078-.193l.177-.038c.43-.089.859-.185 1.285-.292.213-.053.424-.112.636-.17.258-.07.515-.141.77-.219a31.206 31.206 0 0 0 2.319-.801l.049-.017c.06-.024.122-.045.183-.069l38.127 38.128 17.087 17.087 3.542 3.541a29.746 29.746 0 0 0-1.877 10.466c0 16.542 13.458 30 30 30s30-13.458 30-30-13.458-30-30-30zm0 52c-12.13 0-22-9.87-22-22 0-3.375.745-6.614 2.214-9.628l1.25-2.564-9.036-9.036-57.664-57.665-2.591 1.324A23.243 23.243 0 0 1 47.5 71C34.542 71 24 60.458 24 47.5c0-.595.022-1.188.066-1.777l9.105 9.106C36.064 57.72 39.91 59.314 44 59.314s7.936-1.593 10.829-4.485C57.72 51.936 59.314 48.09 59.314 44s-1.593-7.936-4.485-10.829l-9.106-9.105c.59-.044 1.182-.066 1.777-.066C60.458 24 71 34.542 71 47.5c0 3.75-.864 7.342-2.567 10.675l-1.324 2.591 57.665 57.665 9.036 9.036 2.564-1.25a21.791 21.791 0 0 1 9.628-2.215c12.13 0 22 9.87 22 22s-9.87 22-22 22zm0-36c-7.72 0-14 6.28-14 14s6.28 14 14 14 14-6.28 14-14-6.28-14-14-14zm0 20c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6z"
      opacity="0.48"
    />
  </svg>
);

const reports = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25.52"
    height="25.52"
    viewBox="0 0 25.52 25.52"
  >
    <g
      id="reports_deactive_state"
      data-name="reports deactive state"
      transform="translate(0.75 0.77)"
    >
      <g id="Group_913" data-name="Group 913" opacity="0.48">
        <g id="Group_914" data-name="Group 914">
          <path
            id="Path_276"
            data-name="Path 276"
            d="M33.155,30.922a10.725,10.725,0,1,1-11-11V30.639a.283.283,0,0,0,.283.283H33.155Z"
            transform="translate(-11.708 -17.365)"
            fill="none"
            stroke="#102e35"
            strokeWidth="1.5"
          />
          <path
            id="Path_277"
            data-name="Path 277"
            d="M65.382,22.217H54.943V11.778A10.739,10.739,0,0,1,65.382,22.217Z"
            transform="translate(-41.382 -11.778)"
            fill="none"
            stroke="#102e35"
            strokeWidth="1.5"
          />
        </g>
      </g>
    </g>
  </svg>
);

const payments = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25.5"
    height="18.802"
    viewBox="0 0 25.5 18.802"
  >
    <g
      id="payments_deactive_state"
      data-name="payments deactive state"
      transform="translate(0.75 0.75)"
    >
      <g id="Group_915" data-name="Group 915" opacity="0.48">
        <path
          id="Path_278"
          data-name="Path 278"
          d="M21.842,45.12v8.8a1.926,1.926,0,0,0,1.926,1.926H43.914a1.926,1.926,0,0,0,1.926-1.926v-8.8Z"
          transform="translate(-21.842 -38.548)"
          fill="none"
          stroke="#102e35"
          strokeWidth="1.5"
        />
        <path
          id="Path_279"
          data-name="Path 279"
          d="M45.842,33.026v-1.4A1.926,1.926,0,0,0,43.916,29.7H23.77a1.926,1.926,0,0,0-1.928,1.924v1.4Z"
          transform="translate(-21.842 -29.7)"
          fill="none"
          stroke="#102e35"
          strokeWidth="1.5"
        />
      </g>
    </g>
  </svg>
);

const settings = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25.038"
    height="25.5"
    viewBox="0 0 25.038 25.5"
  >
    <g
      id="settings_deactive_state"
      data-name="settings deactive state"
      transform="translate(0.919 0.75)"
    >
      <g id="Group_1751" data-name="Group 1751">
        <rect
          id="Rectangle_193"
          data-name="Rectangle 193"
          width="24"
          height="24"
          fill="none"
        />
        <path
          id="Path_104"
          data-name="Path 104"
          d="M271.447,15a3,3,0,1,0-3.053-3A3.036,3.036,0,0,0,271.447,15Zm-6.258-9.6a8.655,8.655,0,0,1,3.663-1.95L270.074,0h3.053l1.221,3.45A10.718,10.718,0,0,1,278.01,5.4l3.663-.75,1.526,2.7-2.442,2.7A8.408,8.408,0,0,1,280.91,12c0,.6-.153,1.35-.153,1.95l2.442,2.7-1.526,2.7-3.663-.75a8.655,8.655,0,0,1-3.663,1.95L273.126,24h-3.053l-1.221-3.45a10.718,10.718,0,0,1-3.663-1.95l-3.663.75L260,16.65l2.442-2.7a8.408,8.408,0,0,1-.153-1.95c0-.6.153-1.35.153-1.95L260,7.35l1.526-2.7Z"
          transform="translate(-260)"
          fill="none"
          stroke="#8c9a9d"
          strokeWidth="1.5"
          fillRule="evenodd"
        />
      </g>
    </g>
  </svg>
);

const dashboardCol = (
  <svg
    id="Dashboard_Collaspsed_deactive"
    data-name="Dashboard Collaspsed deactive"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      id="Path_1265"
      data-name="Path 1265"
      d="M0,21H24v3H0ZM0,10.5H24V18H0ZM10.5,0H24V7.5H10.5ZM0,0H7.5V7.5H0Z"
      fill="#869599"
      fillRule="evenodd"
    />
  </svg>
);

const parkingCol = (
  <svg
    id="Parking_Mgmt_Collapsed_Deactive"
    data-name="Parking Mgmt Collapsed Deactive"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g id="Group_1895" data-name="Group 1895" opacity="0.5">
      <path
        id="Path_270"
        data-name="Path 270"
        d="M32.242,12.8H17.558A4.68,4.68,0,0,0,12.9,17.458V32.142A4.68,4.68,0,0,0,17.558,36.8H32.242A4.68,4.68,0,0,0,36.9,32.142V17.49A4.645,4.645,0,0,0,32.242,12.8ZM30.948,24.153a4.474,4.474,0,0,1-1.035,1.617A4.817,4.817,0,0,1,28.231,26.9a5.493,5.493,0,0,1-2.232.42h-3.04v5.11H19.628v-15.2h6.4a5.544,5.544,0,0,1,2.264.453,4.751,4.751,0,0,1,1.65,1.164A5.22,5.22,0,0,1,31.3,22.277,5.362,5.362,0,0,1,30.948,24.153Z"
        transform="translate(-12.9 -12.8)"
        fill="#102e35"
      />
      <path
        id="Path_271"
        data-name="Path 271"
        d="M47.04,36.5H44v3.687h3.04a1.919,1.919,0,0,0,.744-.162,1.607,1.607,0,0,0,.615-.42,2.072,2.072,0,0,0,.42-.615,1.919,1.919,0,0,0,.162-.744,1.645,1.645,0,0,0-.55-1.294A2.053,2.053,0,0,0,47.04,36.5Z"
        transform="translate(-33.941 -28.834)"
        fill="#102e35"
      />
    </g>
  </svg>
);

const orgCol = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="192"
    height="192"
    viewBox="0 0 192 192"
  >
    <path d="M108.748 105.6l2.569-2.331c-6.12-9.17-15.061-16.213-25.429-20.044C96.7 77.01 104 65.359 104 52.028c0-19.836-16.15-35.973-36-35.973S32 32.192 32 52.028c0 13.308 7.276 24.943 18.056 31.165C30.2 90.517 16 109.631 16 132h8c0-24.262 19.738-44 44-44 15.542 0 29.603 8.257 37.454 20.923a45.432 45.432 0 0 1 3.294-3.324zM40 52.027c0-15.424 12.56-27.973 28-27.973s28 12.549 28 27.973S83.439 80 68 80 40 67.452 40 52.028zm135.688 81.993a37.303 37.303 0 0 0-1.539-6.644l-.865-2.626-8.456-.401c-.114-.2-.23-.398-.348-.596l3.822-7.555-1.858-2.049a37.04 37.04 0 0 0-10.807-8.225l-2.47-1.244-6.264 5.697c-.22-.062-.443-.12-.666-.176l-2.64-8.043-2.762-.135a37.254 37.254 0 0 0-6.814.288c-2.227.302-4.462.82-6.644 1.539l-2.626.865-.401 8.456c-.2.114-.398.23-.596.348l-7.555-3.822-2.049 1.858a37.049 37.049 0 0 0-8.225 10.807l-1.244 2.47 5.697 6.264c-.062.22-.12.443-.176.666l-8.043 2.64-.135 2.762c-.111 2.294-.015 4.586.288 6.814s.82 4.462 1.539 6.644l.865 2.626 8.456.401c.114.2.23.398.348.596l-3.822 7.555 1.858 2.049a37.051 37.051 0 0 0 10.807 8.224l2.469 1.245 6.262-5.694c.223.062.447.12.67.177l2.639 8.04 2.762.134a36.958 36.958 0 0 0 6.813-.287 37.303 37.303 0 0 0 6.645-1.54l2.626-.865.401-8.456c.2-.114.398-.23.596-.348l7.555 3.822 2.049-1.858a37.049 37.049 0 0 0 8.225-10.807l1.244-2.47-5.697-6.264c.062-.22.12-.443.176-.666l8.043-2.64.135-2.762a37.297 37.297 0 0 0-.288-6.814zm-14.926 6.062l-.393 2.412a21.497 21.497 0 0 1-1.057 3.997l-.85 2.293 5.096 5.602a28.959 28.959 0 0 1-3.183 4.182l-6.757-3.418-1.983 1.43a21.558 21.558 0 0 1-3.573 2.084l-2.218 1.022-.36 7.558a28.433 28.433 0 0 1-5.207.707l-2.361-7.196-2.419-.388a20.975 20.975 0 0 1-3.99-1.056l-2.292-.85-5.602 5.096a28.933 28.933 0 0 1-4.182-3.183l3.418-6.757-1.43-1.983a21.558 21.558 0 0 1-2.084-3.573l-1.022-2.218-7.558-.36a28.433 28.433 0 0 1-.707-5.207l7.19-2.36.393-2.412c.22-1.354.577-2.698 1.057-3.997l.85-2.293-5.096-5.602a28.959 28.959 0 0 1 3.183-4.182l6.757 3.418 1.983-1.43a21.558 21.558 0 0 1 3.573-2.084l2.218-1.022.36-7.558a28.433 28.433 0 0 1 5.207-.707l2.36 7.19 2.412.393c1.354.22 2.698.577 3.997 1.057l2.293.85 5.602-5.096a28.964 28.964 0 0 1 4.182 3.183l-3.418 6.757 1.43 1.983a21.558 21.558 0 0 1 2.084 3.573l1.022 2.218 7.558.36a28.433 28.433 0 0 1 .707 5.207l-7.19 2.36zm-29.057-13.086c-6.632 4.027-8.75 12.7-4.723 19.333 2.645 4.355 7.292 6.764 12.05 6.764a13.99 13.99 0 0 0 7.283-2.042c6.632-4.028 8.75-12.7 4.722-19.333-4.028-6.632-12.7-8.751-19.332-4.722zm10.436 17.182a6.037 6.037 0 0 1-8.286-2.024 6.038 6.038 0 0 1 2.024-8.285 6.034 6.034 0 0 1 8.285 2.024 6.037 6.037 0 0 1-2.023 8.285z" />
  </svg>
);

const userCol = (
  <svg
    id="user_management_Collapsed_deactive"
    data-name="user management Collapsed deactive"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      id="Union_47"
      data-name="Union 47"
      d="M0,24.6V21.527c0-3.383,5.535-6.151,12.3-6.151s12.3,2.768,12.3,6.151V24.6ZM6.15,6.151A6.15,6.15,0,1,1,12.3,12.3,6.151,6.151,0,0,1,6.15,6.151Z"
      fill="#869599"
    />
  </svg>
);

const roleCol = (
  <svg
    id="role_management_Collapsed_deactive"
    data-name="role management Collapsed deactive"
    xmlns="http://www.w3.org/2000/svg"
    width="34.286"
    height="24"
    viewBox="0 0 34.286 24"
  >
    <path
      id="Path_291"
      data-name="Path 291"
      d="M15.074,20.809c-4.011,0-12,2.006-12,6v3h24v-3C27.074,22.815,19.085,20.809,15.074,20.809Zm0-3a6,6,0,1,0-6-6A6.007,6.007,0,0,0,15.074,17.809Zm12.069,3.1a7.187,7.187,0,0,1,3.36,5.9v3H37.36v-3C37.36,23.346,31.36,21.375,27.143,20.912Zm-1.783-3.1a6,6,0,1,0,0-12,5.907,5.907,0,0,0-2.571.6,9.362,9.362,0,0,1,0,10.8A5.907,5.907,0,0,0,25.36,17.809Z"
      transform="translate(-3.074 -5.809)"
      fill="#869599"
    />
  </svg>
);

const serviceCol = (
  <svg
    id="services_requested_collapsed_deactive"
    data-name="services requested collapsed deactive"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      id="Path_273"
      data-name="Path 273"
      d="M24.155,13.784a.214.214,0,0,0,.179-.175,7.414,7.414,0,0,0,0-2.461.214.214,0,0,0-.179-.175l-1.828-.287a.531.531,0,0,1-.347-.838l1.09-1.494a.215.215,0,0,0,0-.25,7.383,7.383,0,0,0-1.741-1.741.215.215,0,0,0-.25,0l-1.494,1.09a.532.532,0,0,1-.838-.347l-.287-1.828a.214.214,0,0,0-.175-.179,7.412,7.412,0,0,0-2.461,0,.214.214,0,0,0-.175.179l-.287,1.828a.532.532,0,0,1-.839.347l-1.493-1.09a.215.215,0,0,0-.25,0A7.384,7.384,0,0,0,11.043,8.1a.215.215,0,0,0,0,.25l1.09,1.494a.531.531,0,0,1-.347.838l-1.828.287a.215.215,0,0,0-.179.175,7.428,7.428,0,0,0,0,2.461.215.215,0,0,0,.179.175l1.828.287a.531.531,0,0,1,.347.838L11.046,16.4a.215.215,0,0,0,0,.25,7.378,7.378,0,0,0,1.741,1.741.215.215,0,0,0,.25,0l1.493-1.09a.532.532,0,0,1,.839.347l.287,1.828a.214.214,0,0,0,.175.179,7.412,7.412,0,0,0,2.461,0,.214.214,0,0,0,.175-.179l.287-1.828a.532.532,0,0,1,.839-.347l1.493,1.09a.215.215,0,0,0,.25,0,7.383,7.383,0,0,0,1.741-1.741.215.215,0,0,0,0-.25l-1.09-1.494a.532.532,0,0,1,.116-.743Zm-7.1,1.464a2.869,2.869,0,1,1,2.87-2.869h0A2.87,2.87,0,0,1,17.058,15.248Zm12.053,7.4a8.014,8.014,0,0,1-.85.644c0,.32-1.855,1.6-2.13,1.813a25.168,25.168,0,0,1-2.877,1.926,25.861,25.861,0,0,1-6.1,1.941,37.48,37.48,0,0,1-7.273-.718,8.347,8.347,0,0,0-2.155-.015V22.752c0-.012,0-.023,0-.035a6.4,6.4,0,0,1,2.262-1.056,10.416,10.416,0,0,1,3.8.015,9.732,9.732,0,0,0,3.078.018,18.849,18.849,0,0,0,2.5-.429c.86-.28,1.41-.241,1.724.323a.886.886,0,0,1-.366,1.173,7.4,7.4,0,0,1-2.077,1.123,25.836,25.836,0,0,1-3.341.7,22.02,22.02,0,0,0,2.158.539,16.042,16.042,0,0,0,4.546-.237c1.6-.382,4.007-2.459,5.017-2.825a2.08,2.08,0,0,1,1.69-.137C28.958,22.048,29.208,22.52,29.111,22.648Z"
      transform="translate(-7.726 -5)"
      fill="#869599"
    />
  </svg>
);

const reportCol = (
  <svg
    id="reports_Collapsed_deactive"
    data-name="reports Collapsed deactive"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g id="Group_914" data-name="Group 914">
      <path
        id="Path_276"
        data-name="Path 276"
        d="M33.155,30.922a10.725,10.725,0,1,1-11-11V30.639a.283.283,0,0,0,.283.283H33.155Z"
        transform="translate(-11.708 -17.365)"
        fill="#869599"
      />
      <path
        id="Path_277"
        data-name="Path 277"
        d="M65.382,22.217H54.943V11.778A10.739,10.739,0,0,1,65.382,22.217Z"
        transform="translate(-41.382 -11.778)"
        fill="#869599"
      />
    </g>
  </svg>
);

const paymentCol = (
  <svg
    id="payments_collapsed_deactive"
    data-name="payments collapsed deactive"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      id="Path_278"
      data-name="Path 278"
      d="M21.842,45.12v8.8a1.926,1.926,0,0,0,1.926,1.926H43.914a1.926,1.926,0,0,0,1.926-1.926v-8.8Z"
      transform="translate(-21.842 -38.548)"
      fill="#869599"
    />
    <path
      id="Path_279"
      data-name="Path 279"
      d="M45.842,33.026v-1.4A1.926,1.926,0,0,0,43.916,29.7H23.77a1.926,1.926,0,0,0-1.928,1.924v1.4Z"
      transform="translate(-21.842 -29.7)"
      fill="#869599"
    />
  </svg>
);

const settingCol = (
  <svg
    id="settings_collapsed_deactive"
    data-name="settings collapsed deactive"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      id="Path_1266"
      data-name="Path 1266"
      d="M271.447,15a3,3,0,1,0-3.053-3A3.036,3.036,0,0,0,271.447,15Zm-6.258-9.6a8.655,8.655,0,0,1,3.663-1.95L270.074,0h3.053l1.221,3.45A10.718,10.718,0,0,1,278.01,5.4l3.663-.75,1.526,2.7-2.442,2.7A8.408,8.408,0,0,1,280.91,12c0,.6-.153,1.35-.153,1.95l2.442,2.7-1.526,2.7-3.663-.75a8.655,8.655,0,0,1-3.663,1.95L273.126,24h-3.053l-1.221-3.45a10.718,10.718,0,0,1-3.663-1.95l-3.663.75L260,16.65l2.442-2.7a8.408,8.408,0,0,1-.153-1.95c0-.6.153-1.35.153-1.95L260,7.35l1.526-2.7Z"
      transform="translate(-260)"
      fill="#869599"
      fillRule="evenodd"
    />
  </svg>
);

const legalDocumentsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="160"
    height="128"
    viewBox="0 0 160 128"
  >
    <path
      id="briefcase"
      d="M128,48V32H64V48H16V160H176V48ZM72,40h48v8H72ZM64,56H168V80H24V56Zm64,32h12v8H128ZM52,88H64v8H52ZM24,152V88H44v16H72V88h48v16h28V88h20v64Z"
      transform="translate(-16 -32)"
      fill="#929fa2"
    />
  </svg>
);

const emptyAvailability = (
  <svg
    width="165"
    height="194"
    viewBox="0 0 165 194"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M49.6383 178.361V189.997H48.2747L41.9338 180.861H41.8201V189.997H40.411V178.361H41.7747L48.1383 187.52H48.252V178.361H49.6383ZM55.8216 190.179C55.0337 190.179 54.3424 189.991 53.7477 189.616C53.1568 189.241 52.6947 188.717 52.3613 188.043C52.0318 187.368 51.867 186.58 51.867 185.679C51.867 184.77 52.0318 183.976 52.3613 183.298C52.6947 182.62 53.1568 182.094 53.7477 181.719C54.3424 181.344 55.0337 181.156 55.8216 181.156C56.6094 181.156 57.2988 181.344 57.8897 181.719C58.4844 182.094 58.9466 182.62 59.2761 183.298C59.6094 183.976 59.7761 184.77 59.7761 185.679C59.7761 186.58 59.6094 187.368 59.2761 188.043C58.9466 188.717 58.4844 189.241 57.8897 189.616C57.2988 189.991 56.6094 190.179 55.8216 190.179ZM55.8216 188.974C56.42 188.974 56.9125 188.821 57.2988 188.514C57.6852 188.207 57.9712 187.804 58.1568 187.304C58.3424 186.804 58.4352 186.262 58.4352 185.679C58.4352 185.096 58.3424 184.552 58.1568 184.048C57.9712 183.544 57.6852 183.137 57.2988 182.827C56.9125 182.516 56.42 182.361 55.8216 182.361C55.2231 182.361 54.7306 182.516 54.3443 182.827C53.9579 183.137 53.6719 183.544 53.4863 184.048C53.3007 184.552 53.2079 185.096 53.2079 185.679C53.2079 186.262 53.3007 186.804 53.4863 187.304C53.6719 187.804 53.9579 188.207 54.3443 188.514C54.7306 188.821 55.2231 188.974 55.8216 188.974ZM70.0957 189.997H66.5048V178.361H70.2548C71.3836 178.361 72.3495 178.594 73.1525 179.06C73.9556 179.522 74.5711 180.186 74.9991 181.054C75.4271 181.918 75.6412 182.952 75.6412 184.156C75.6412 185.368 75.4252 186.412 74.9934 187.287C74.5616 188.158 73.9328 188.829 73.1071 189.298C72.2813 189.764 71.2775 189.997 70.0957 189.997ZM67.9139 188.747H70.0048C70.9669 188.747 71.7643 188.561 72.3968 188.19C73.0294 187.819 73.501 187.291 73.8116 186.605C74.1222 185.919 74.2775 185.103 74.2775 184.156C74.2775 183.217 74.1241 182.408 73.8173 181.73C73.5105 181.048 73.0521 180.525 72.4423 180.162C71.8324 179.794 71.073 179.611 70.1639 179.611H67.9139V188.747ZM80.3912 190.202C79.8381 190.202 79.3362 190.097 78.8855 189.889C78.4347 189.677 78.0768 189.372 77.8116 188.974C77.5465 188.573 77.4139 188.088 77.4139 187.52C77.4139 187.02 77.5124 186.614 77.7093 186.304C77.9063 185.989 78.1696 185.743 78.4991 185.565C78.8287 185.387 79.1923 185.255 79.59 185.168C79.9915 185.077 80.3949 185.005 80.8002 184.952C81.3306 184.883 81.7605 184.832 82.09 184.798C82.4234 184.76 82.6658 184.698 82.8173 184.611C82.9726 184.524 83.0502 184.372 83.0502 184.156V184.111C83.0502 183.55 82.8968 183.114 82.59 182.804C82.287 182.493 81.8268 182.338 81.2093 182.338C80.5692 182.338 80.0673 182.478 79.7037 182.758C79.34 183.039 79.0843 183.338 78.9366 183.656L77.6639 183.202C77.8912 182.671 78.1942 182.258 78.573 181.963C78.9556 181.664 79.3722 181.455 79.823 181.338C80.2775 181.217 80.7245 181.156 81.1639 181.156C81.4442 181.156 81.7662 181.19 82.1298 181.258C82.4972 181.323 82.8514 181.457 83.1923 181.662C83.537 181.866 83.823 182.175 84.0502 182.588C84.2775 183.001 84.3912 183.554 84.3912 184.247V189.997H83.0502V188.815H82.9821C82.8912 189.005 82.7396 189.207 82.5275 189.423C82.3154 189.639 82.0332 189.823 81.6809 189.974C81.3287 190.126 80.8987 190.202 80.3912 190.202ZM80.5957 188.997C81.126 188.997 81.573 188.893 81.9366 188.685C82.304 188.476 82.5806 188.207 82.7662 187.878C82.9556 187.548 83.0502 187.202 83.0502 186.838V185.611C82.9934 185.679 82.8684 185.741 82.6752 185.798C82.4859 185.851 82.2662 185.899 82.0162 185.94C81.7699 185.978 81.5294 186.012 81.2946 186.043C81.0635 186.069 80.876 186.092 80.7321 186.111C80.3836 186.156 80.0578 186.23 79.7548 186.332C79.4556 186.431 79.2131 186.58 79.0275 186.781C78.8457 186.978 78.7548 187.247 78.7548 187.588C78.7548 188.054 78.9271 188.406 79.2718 188.645C79.6203 188.88 80.0616 188.997 80.5957 188.997ZM90.6341 181.27V182.406H86.1113V181.27H90.6341ZM87.4295 179.179H88.7704V187.497C88.7704 187.876 88.8253 188.16 88.9352 188.349C89.0488 188.535 89.1928 188.66 89.367 188.724C89.545 188.785 89.7325 188.815 89.9295 188.815C90.0772 188.815 90.1984 188.808 90.2931 188.793C90.3878 188.774 90.4636 188.758 90.5204 188.747L90.7931 189.952C90.7022 189.986 90.5753 190.02 90.4125 190.054C90.2496 190.092 90.0431 190.111 89.7931 190.111C89.4144 190.111 89.0431 190.029 88.6795 189.866C88.3197 189.704 88.0204 189.455 87.7818 189.122C87.5469 188.789 87.4295 188.368 87.4295 187.861V179.179ZM95.2193 190.202C94.6663 190.202 94.1644 190.097 93.7136 189.889C93.2628 189.677 92.9049 189.372 92.6397 188.974C92.3746 188.573 92.242 188.088 92.242 187.52C92.242 187.02 92.3405 186.614 92.5375 186.304C92.7344 185.989 92.9977 185.743 93.3272 185.565C93.6568 185.387 94.0204 185.255 94.4181 185.168C94.8197 185.077 95.2231 185.005 95.6284 184.952C96.1587 184.883 96.5886 184.832 96.9181 184.798C97.2515 184.76 97.4939 184.698 97.6454 184.611C97.8007 184.524 97.8784 184.372 97.8784 184.156V184.111C97.8784 183.55 97.725 183.114 97.4181 182.804C97.1151 182.493 96.6549 182.338 96.0375 182.338C95.3973 182.338 94.8954 182.478 94.5318 182.758C94.1681 183.039 93.9125 183.338 93.7647 183.656L92.492 183.202C92.7193 182.671 93.0223 182.258 93.4011 181.963C93.7837 181.664 94.2003 181.455 94.6511 181.338C95.1056 181.217 95.5526 181.156 95.992 181.156C96.2723 181.156 96.5943 181.19 96.9579 181.258C97.3253 181.323 97.6795 181.457 98.0204 181.662C98.3651 181.866 98.6511 182.175 98.8784 182.588C99.1056 183.001 99.2193 183.554 99.2193 184.247V189.997H97.8784V188.815H97.8102C97.7193 189.005 97.5678 189.207 97.3556 189.423C97.1435 189.639 96.8613 189.823 96.5091 189.974C96.1568 190.126 95.7269 190.202 95.2193 190.202ZM95.4238 188.997C95.9541 188.997 96.4011 188.893 96.7647 188.685C97.1322 188.476 97.4087 188.207 97.5943 187.878C97.7837 187.548 97.8784 187.202 97.8784 186.838V185.611C97.8216 185.679 97.6966 185.741 97.5034 185.798C97.314 185.851 97.0943 185.899 96.8443 185.94C96.5981 185.978 96.3575 186.012 96.1227 186.043C95.8916 186.069 95.7041 186.092 95.5602 186.111C95.2117 186.156 94.8859 186.23 94.5829 186.332C94.2837 186.431 94.0413 186.58 93.8556 186.781C93.6738 186.978 93.5829 187.247 93.5829 187.588C93.5829 188.054 93.7553 188.406 94.1 188.645C94.4484 188.88 94.8897 188.997 95.4238 188.997ZM107.508 184.747V189.997H106.167V178.361H107.508V182.633H107.621C107.826 182.183 108.133 181.825 108.542 181.56C108.955 181.291 109.504 181.156 110.189 181.156C110.784 181.156 111.305 181.275 111.752 181.514C112.199 181.749 112.546 182.111 112.792 182.599C113.042 183.084 113.167 183.702 113.167 184.452V189.997H111.826V184.543C111.826 183.849 111.646 183.313 111.286 182.935C110.93 182.552 110.436 182.361 109.803 182.361C109.364 182.361 108.97 182.454 108.621 182.639C108.277 182.825 108.004 183.096 107.803 183.452C107.606 183.808 107.508 184.239 107.508 184.747ZM119.279 190.179C118.438 190.179 117.713 189.993 117.103 189.622C116.497 189.247 116.029 188.724 115.699 188.054C115.374 187.38 115.211 186.596 115.211 185.702C115.211 184.808 115.374 184.02 115.699 183.338C116.029 182.652 116.487 182.118 117.074 181.736C117.665 181.349 118.355 181.156 119.143 181.156C119.597 181.156 120.046 181.232 120.489 181.383C120.932 181.535 121.336 181.781 121.699 182.122C122.063 182.459 122.353 182.906 122.569 183.463C122.785 184.02 122.893 184.705 122.893 185.52V186.088H116.165V184.929H121.529C121.529 184.436 121.43 183.997 121.233 183.611C121.04 183.224 120.764 182.919 120.404 182.696C120.048 182.472 119.627 182.361 119.143 182.361C118.608 182.361 118.146 182.493 117.756 182.758C117.37 183.02 117.073 183.361 116.864 183.781C116.656 184.202 116.552 184.652 116.552 185.133V185.906C116.552 186.565 116.665 187.124 116.893 187.582C117.124 188.037 117.444 188.383 117.853 188.622C118.262 188.857 118.737 188.974 119.279 188.974C119.631 188.974 119.949 188.925 120.233 188.827C120.521 188.724 120.769 188.573 120.978 188.372C121.186 188.168 121.347 187.914 121.461 187.611L122.756 187.974C122.62 188.414 122.391 188.8 122.069 189.133C121.747 189.463 121.349 189.721 120.876 189.906C120.402 190.088 119.87 190.179 119.279 190.179ZM124.932 189.997V181.27H126.228V182.588H126.319C126.478 182.156 126.766 181.806 127.182 181.537C127.599 181.268 128.069 181.133 128.591 181.133C128.69 181.133 128.813 181.135 128.961 181.139C129.108 181.143 129.22 181.149 129.296 181.156V182.52C129.251 182.508 129.146 182.491 128.983 182.469C128.824 182.442 128.656 182.429 128.478 182.429C128.054 182.429 127.675 182.518 127.341 182.696C127.012 182.87 126.751 183.113 126.557 183.423C126.368 183.73 126.273 184.08 126.273 184.474V189.997H124.932ZM134.279 190.179C133.438 190.179 132.713 189.993 132.103 189.622C131.497 189.247 131.029 188.724 130.699 188.054C130.374 187.38 130.211 186.596 130.211 185.702C130.211 184.808 130.374 184.02 130.699 183.338C131.029 182.652 131.487 182.118 132.074 181.736C132.665 181.349 133.355 181.156 134.143 181.156C134.597 181.156 135.046 181.232 135.489 181.383C135.932 181.535 136.336 181.781 136.699 182.122C137.063 182.459 137.353 182.906 137.569 183.463C137.785 184.02 137.893 184.705 137.893 185.52V186.088H131.165V184.929H136.529C136.529 184.436 136.43 183.997 136.233 183.611C136.04 183.224 135.764 182.919 135.404 182.696C135.048 182.472 134.627 182.361 134.143 182.361C133.608 182.361 133.146 182.493 132.756 182.758C132.37 183.02 132.073 183.361 131.864 183.781C131.656 184.202 131.552 184.652 131.552 185.133V185.906C131.552 186.565 131.665 187.124 131.893 187.582C132.124 188.037 132.444 188.383 132.853 188.622C133.262 188.857 133.737 188.974 134.279 188.974C134.631 188.974 134.949 188.925 135.233 188.827C135.521 188.724 135.769 188.573 135.978 188.372C136.186 188.168 136.347 187.914 136.461 187.611L137.756 187.974C137.62 188.414 137.391 188.8 137.069 189.133C136.747 189.463 136.349 189.721 135.876 189.906C135.402 190.088 134.87 190.179 134.279 190.179Z"
      fill="white"
    />
    <g opacity="0.7">
      <path
        d="M104.606 36.1677H60.2059C59.1943 36.1691 58.2244 36.5716 57.5091 37.2869C56.7937 38.0023 56.3913 38.9721 56.3899 39.9838V138.657L55.8809 138.812L44.9899 142.157C44.4737 142.314 43.916 142.261 43.4394 142.007C42.9628 141.754 42.6062 141.322 42.4479 140.806L10.0479 34.9788C9.89012 34.4625 9.94379 33.9047 10.1971 33.428C10.4505 32.9514 10.8828 32.5948 11.3989 32.4368L28.1829 27.2978L76.8409 12.4038L93.6249 7.26475C93.8803 7.18614 94.1488 7.15866 94.4148 7.18388C94.6809 7.20909 94.9393 7.28652 95.1754 7.41172C95.4115 7.53692 95.6206 7.70744 95.7907 7.91352C95.9609 8.11961 96.0887 8.35722 96.1669 8.61276L104.448 35.6628L104.606 36.1677Z"
        fill="#F2F2F2"
      />
      <path
        d="M114.295 35.6592L104.314 3.05922C104.148 2.5162 103.876 2.0112 103.515 1.57308C103.154 1.13496 102.71 0.772294 102.208 0.505787C101.707 0.23928 101.158 0.0741412 100.593 0.0198254C100.027 -0.0344904 99.457 0.0230678 98.914 0.189213L75.314 7.41222L26.658 22.3122L3.058 29.5382C1.96208 29.8748 1.04441 30.6324 0.506368 31.6448C-0.0316779 32.6571 -0.146184 33.8416 0.187978 34.9382L34.301 146.357C34.5727 147.243 35.1211 148.018 35.8657 148.569C36.6102 149.12 37.5118 149.417 38.438 149.418C38.8665 149.418 39.2926 149.354 39.702 149.227L55.878 144.276L56.387 144.118V143.58L55.878 143.735L39.552 148.735C38.5844 149.03 37.5392 148.929 36.646 148.454C35.7527 147.98 35.0841 147.17 34.787 146.203L0.679982 34.7802C0.532725 34.3012 0.481401 33.7978 0.528951 33.2989C0.5765 32.8 0.721984 32.3153 0.957082 31.8727C1.19218 31.4301 1.51228 31.0382 1.89904 30.7195C2.28579 30.4007 2.73162 30.1614 3.21099 30.0152L26.811 22.7892L75.467 7.89522L99.067 0.669224C99.5461 0.522124 100.05 0.470943 100.548 0.51862C101.047 0.566297 101.532 0.711892 101.975 0.947071C102.417 1.18225 102.809 1.5024 103.128 1.88919C103.446 2.27599 103.686 2.72183 103.832 3.20122L113.767 35.6552L113.925 36.1642H114.454L114.295 35.6592Z"
        fill="white"
      />
      <path
        d="M31.2141 32.516C30.7237 32.5156 30.2463 32.3581 29.852 32.0665C29.4577 31.775 29.1672 31.3647 29.0231 30.896L25.7461 20.196C25.6579 19.9084 25.6273 19.6064 25.6559 19.307C25.6845 19.0076 25.7719 18.7168 25.9129 18.4512C26.054 18.1856 26.246 17.9504 26.478 17.759C26.7101 17.5677 26.9775 17.4239 27.2651 17.336L72.0281 3.63597C72.6088 3.45873 73.2361 3.51914 73.7723 3.80392C74.3085 4.08871 74.7098 4.57461 74.8881 5.15497L78.1651 15.855C78.3423 16.4357 78.2819 17.063 77.9971 17.5992C77.7124 18.1354 77.2265 18.5366 76.6461 18.715L31.8831 32.415C31.6664 32.4817 31.4409 32.5157 31.2141 32.516Z"
        fill="#007EBE"
      />
      <path
        d="M48.381 11.4319C51.191 11.4319 53.469 9.15388 53.469 6.34386C53.469 3.53383 51.191 1.25586 48.381 1.25586C45.5709 1.25586 43.293 3.53383 43.293 6.34386C43.293 9.15388 45.5709 11.4319 48.381 11.4319Z"
        fill="#007EBE"
      />
      <path
        d="M48.3812 9.56705C50.1606 9.56705 51.6032 8.12451 51.6032 6.34505C51.6032 4.56559 50.1606 3.12305 48.3812 3.12305C46.6017 3.12305 45.1592 4.56559 45.1592 6.34505C45.1592 8.12451 46.6017 9.56705 48.3812 9.56705Z"
        fill="white"
      />
      <path
        d="M153.325 148.114H67.331C66.7575 148.114 66.2076 147.885 65.8021 147.48C65.3965 147.074 65.1685 146.525 65.168 145.951V42.911C65.1685 42.3375 65.3965 41.7877 65.8021 41.3821C66.2076 40.9766 66.7575 40.7486 67.331 40.748H153.326C153.899 40.7486 154.449 40.9766 154.855 41.3821C155.26 41.7877 155.488 42.3375 155.489 42.911V145.951C155.488 146.525 155.26 147.075 154.854 147.48C154.449 147.886 153.899 148.114 153.325 148.114Z"
        fill="white"
      />
      <path
        d="M113.764 35.6592H60.2068C59.0603 35.6608 57.9611 36.117 57.1504 36.9277C56.3396 37.7385 55.8834 38.8376 55.8818 39.9842V143.737L56.3908 143.582V39.9822C56.3922 38.9705 56.7946 38.0007 57.51 37.2853C58.2253 36.57 59.1952 36.1675 60.2068 36.1662H113.921L113.764 35.6592ZM160.45 35.6592H60.2068C59.0603 35.6608 57.9611 36.117 57.1504 36.9277C56.3396 37.7385 55.8834 38.8376 55.8818 39.9842V156.509C55.8834 157.656 56.3396 158.755 57.1504 159.566C57.9611 160.376 59.0603 160.833 60.2068 160.834H160.449C161.595 160.833 162.695 160.376 163.505 159.566C164.316 158.755 164.772 157.656 164.774 156.509V39.9842C164.772 38.8376 164.316 37.7385 163.505 36.9277C162.695 36.117 161.596 35.6608 160.45 35.6592ZM164.266 156.509C164.265 157.521 163.862 158.491 163.147 159.206C162.431 159.921 161.461 160.324 160.45 160.325H60.2068C59.1952 160.324 58.2253 159.921 57.51 159.206C56.7946 158.491 56.3922 157.521 56.3908 156.509V39.9842C56.3922 38.9725 56.7946 38.0027 57.51 37.2873C58.2253 36.572 59.1952 36.1695 60.2068 36.1682H160.449C161.461 36.1695 162.43 36.572 163.146 37.2873C163.861 38.0027 164.264 38.9725 164.265 39.9842L164.266 156.509Z"
        fill="white"
      />
      <path
        d="M133.735 46.8531H86.9218C86.3146 46.8526 85.7325 46.6111 85.3032 46.1818C84.8738 45.7524 84.6324 45.1703 84.6318 44.5631V33.3691C84.6324 32.7619 84.8738 32.1797 85.3032 31.7504C85.7325 31.3211 86.3146 31.0796 86.9218 31.0791H133.736C134.343 31.0796 134.925 31.3211 135.355 31.7504C135.784 32.1797 136.025 32.7619 136.026 33.3691V44.5641C136.025 45.1713 135.783 45.7533 135.354 46.1825C134.924 46.6117 134.342 46.8528 133.735 46.8531Z"
        fill="#007EBE"
      />
      <path
        d="M110.328 31.842C113.138 31.842 115.416 29.564 115.416 26.754C115.416 23.944 113.138 21.666 110.328 21.666C107.518 21.666 105.24 23.944 105.24 26.754C105.24 29.564 107.518 31.842 110.328 31.842Z"
        fill="#007EBE"
      />
      <path
        d="M110.328 29.8533C112.04 29.8533 113.427 28.4658 113.427 26.7543C113.427 25.0427 112.04 23.6553 110.328 23.6553C108.616 23.6553 107.229 25.0427 107.229 26.7543C107.229 28.4658 108.616 29.8533 110.328 29.8533Z"
        fill="white"
      />
    </g>
  </svg>
);

const booking = (
  <svg
    width="165"
    height="25"
    viewBox="0 0 165 194"
    fill="#869599"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M176,136V32H16v104h64v16H64v8h64v-8h-16v-16H176z M24,40h144v88H24V40z M104,152H88v-16h16V152z M116,48h-8v3.91406H84V48
    h-8v3.91406H51.91406v68.17188h88.17188V51.91406H116V48z M60.08594,111.91406V80h71.82812v31.91406H60.08594z M131.91406,60.08594
    V72H60.08594V60.08594H76V64h8v-3.91406h24V64h8v-3.91406H131.91406z"
      fill="#869599"
    />

    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
  </svg>
);

const heatmap=(
 
<svg 
    width="165"
    height="25"
    viewBox="0 0 165 194"
    fill="#869599"
    xmlns="http://www.w3.org/2000/svg">
  <path d="M160 160v-40h-40v16H72v-16H56V72h16V56h48v16h40V32h-40v16H72V32H32v40h16v48H32v40h40v-16h48v16h40zM143.4 40h8.6v24h-24V40h15.4zM40 64V40h24v24H40zm18 88H40v-24h24v24h-6z"
   fill="#869599"/></svg>
)
export const getSVG = (type) => {
  switch (type) {
    case "dashboard":
      return dashboard;
    case "parkingManagement":
      return parkingManagement;
    case "userManagement":
      return userManagement;
    case "organizationManagement":
      return organizationManagement;
    case "roleManagement":
      return roleManagement;
    case "serviceRequest":
      return serviceRequest;
    case "configuration":
      return configuration;
    case "reports":
      return reports;
    case "payments":
      return payments;
    case "settings":
      return settings;
    case "dashboardCol":
      return dashboardCol;
    case "parkingCol":
      return parkingCol;
    case "userCol":
      return userCol;
    case "orgCol":
      return orgCol;
    case "roleCol":
      return roleCol;
    case "serviceCol":
      return serviceCol;
    case "reportCol":
      return reportCol;
    case "paymentCol":
      return paymentCol;
    case "settingCol":
      return settingCol;
    case "legalDocumentsIcon":
      return legalDocumentsIcon;
    case "emptyAvailability":
      return emptyAvailability;
    case "booking":
      return booking;
    case "heatmap":
      return heatmap;
   default:
      return;
  }
};
